import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { FaStar, FaRegHeart, FaHeart } from "react-icons/fa";
import { FiShoppingCart } from "react-icons/fi";
import { CartContext } from "../context/CartContext";
import { formatPrice } from "../lib/formatPrice";

const MAX_TITLE_LENGTH = 32;

export default function Product({ product }) {
  const { addToCart } = useContext(CartContext);
  const [wishlisted, setWishlisted] = useState(false);

  // only append the ellipsis when the title is actually truncated
  const displayTitle =
    product.title.length > MAX_TITLE_LENGTH
      ? `${product.title.substring(0, MAX_TITLE_LENGTH)}…`
      : product.title;

  return (
    <div className="card group relative flex flex-col overflow-hidden hover:border-brand/40 transition-colors">
      {/* new badge */}
      {product.isNewProduct && (
        <span className="absolute top-3 left-3 z-10 bg-brand text-white text-[11px] font-semibold uppercase px-2 py-0.5 rounded">
          New
        </span>
      )}
      {/* wishlist (local toggle) */}
      <button
        type="button"
        onClick={() => setWishlisted((w) => !w)}
        aria-label={wishlisted ? "Remove from wishlist" : "Add to wishlist"}
        aria-pressed={wishlisted}
        className="absolute top-3 right-3 z-10 text-muted hover:text-brand transition-colors">
        {wishlisted ? <FaHeart className="text-brand" /> : <FaRegHeart />}
      </button>

      <Link to={`/product/${product.slug}`} className="flex flex-col items-center px-4 pt-8 pb-5">
        <div className="grad w-full h-[170px] rounded-lg flex items-center justify-center mb-5">
          <img
            className="w-[150px] h-[150px] object-contain transition-transform duration-300 group-hover:scale-95"
            src={`${product.image}`}
            alt={product.title}
            loading="lazy"
          />
        </div>
        {/* rating (decorative placeholder — no rating data in the model yet) */}
        <div className="flex items-center gap-x-0.5 text-amber-400 mb-2" aria-hidden="true">
          {Array.from({ length: 5 }).map((_, i) => (
            <FaStar key={i} className="text-xs" />
          ))}
        </div>
        <div className="text-sm text-ink text-center mb-1">{displayTitle}</div>
        <div className="text-brand font-semibold">
          {formatPrice(product.regularPrice)}
        </div>
      </Link>

      <button
        type="button"
        onClick={() => addToCart(product)}
        className="mt-auto flex items-center justify-center gap-x-2 border-t border-border py-3 text-sm text-muted hover:text-white hover:bg-brand transition-colors">
        <FiShoppingCart /> Add to Cart
      </button>
    </div>
  );
}
